"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ReliabilityDetails = require("./ReliabilityDetails");
Object.keys(_ReliabilityDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReliabilityDetails[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReliabilityDetails[key];
    }
  });
});